import React from 'react';
import RentalAdminLayout from '../../../../layout/equipmentrentaladmin/RentalAdminLayout';
import MechanicFilter from '../../../../components/user/maintain/mechanicfilter/MechanicFilter';

const RequestButton = () => {
    return (
        <RentalAdminLayout>
            <MechanicFilter isRentalAdmin={true} />  {/* ✅ yeh add karein */}
        </RentalAdminLayout>
    );
}

export default RequestButton;